module.exports = __webpack_public_path__ + "static/Multisport-2334d5200a5f713f7801245c93030580.mp4";